import type { ColumnType, FilterValue } from "@p0security/ui";
import {
  FilterDropdown,
  FilterIcon,
} from "components/Policies/common/TablePrimitives";
import type { Key } from "react";

/** Builds the filter-related props for a free-text-filterable antd column,
 * controlled by a URL-backed value/setter rather than antd's internal state. */
export const buildTextFilterColumnProps = <T,>(args: {
  value: string | null;
  onChange: (value: string | null) => void;
  onFilter: (value: Key | boolean, record: T) => boolean;
  placeholder?: string;
}): Partial<ColumnType<T>> => ({
  filterDropdown: ({ confirm }) => (
    <FilterDropdown
      value={args.value}
      onChange={args.onChange}
      confirm={confirm}
      placeholder={args.placeholder ?? "Search..."}
    />
  ),
  filterIcon: FilterIcon,
  filteredValue: args.value ? [args.value] : [],
  onFilter: args.onFilter,
});

/** Builds the filter-related props for an antd native multi-select column,
 * controlled by a URL-backed array value/setter rather than antd's internal state. */
export const buildMultiFilterColumnProps = <T,>(args: {
  filteredValue: FilterValue | null | undefined;
  options: { text: string; value: string }[];
  onFilter: (value: Key | boolean, record: T) => boolean;
}): Partial<ColumnType<T>> => ({
  filters: args.options.map((o) => ({ text: o.text, value: o.value })),
  filteredValue: args.filteredValue ?? [],
  onFilter: args.onFilter,
});
